<mat-card>
    <mat-spinner *ngIf="isLoading"></mat-spinner>

    <form [formGroup]="form" (submit)="onSavePost()" *ngIf="!isLoading">
        <mat-form-field>
            <input matInput type="text" name="title" formControlName="title" placeholder="photo's name" required>
            <mat-error *ngIf="form.get('title').invalid">Please a photo name</mat-error>
        </mat-form-field>

        <div>
            <button mat-stroked-button type="button" (click)="filePicker.click()"> pick image</button>
            <input type="file" #filePicker (change)="onImagePicked($event.target.files)" multiple>
        </div>

        <!-- image preview -->
        <div class="image-previev" *ngIf="imagePreview !=='' && imagePreview && form.get('image').valid">
            <img [src]="imagePreview" [alt]="form.value.title" srcset="">
        </div>


        <mat-form-field>
            <textarea matInput rows="4" name="content" placeholder="Small discription" formControlName="content"></textarea>
            <mat-error *ngIf="form.get('content').invalid">Please enter a post content.</mat-error>
        </mat-form-field>

        <button mat-raised-button color="accent" type="submit">Save Image
    </button>

    </form>
</mat-card>